import {
  VERIFY_OTP_INVALID_CUSTOMER,
  VERIFY_OTP_INVALID_DETAILS,
  VERIFY_OTP_INVALID_HASH,
  VERIFY_OTP_INVALID_OTP,
  VERIFY_OTP_SUCCESS,
  RESET_VERIFY_OTP,
  LOADING_VERIFY_OTP
} from "../types";

const initialState = {
  isLoading: false,
  invalidOTP: false,
  success: false,
  invalidHash: false,
  invalidCustomer: false,
  invalidDetails: false,
  status: "",
  networkError: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_VERIFY_OTP:
      return {
        ...state,
        isLoading: true,
        invalidOTP: false,
        success: false,
        invalidHash: false,
        invalidCustomer: false,
        invalidDetails: false,
        status: "",
        networkError: ""
      };

    case VERIFY_OTP_INVALID_OTP:
      return {
        ...state,
        isLoading: false,
        invalidOTP: true,
        success: false,
        invalidHash: false,
        invalidCustomer: false,
        invalidDetails: false,
        status: "Invalid OTP, Please try again",
        networkError: ""
      };

    case VERIFY_OTP_INVALID_HASH:
      return {
        ...state,
        isLoading: false,
        invalidOTP: false,
        success: false,
        invalidHash: true,
        invalidCustomer: false,
        invalidDetails: false,
        status: "Invalid hash, Please try again",
        networkError: ""
      };

    case VERIFY_OTP_INVALID_CUSTOMER:
      return {
        ...state,
        isLoading: false,
        invalidOTP: false,
        success: false,
        invalidHash: false,
        invalidCustomer: true,
        invalidDetails: false,
        status: "Invalid Customer",
        networkError: ""
      };
    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        invalidOTP: false,
        success: true,
        invalidHash: false,
        invalidCustomer: false,
        invalidDetails: false,
        status: "Verified Successfully!",
        networkError: ""
      };

    case VERIFY_OTP_INVALID_DETAILS:
      return {
        ...state,
        isLoading: false,
        invalidOTP: false,
        success: false,
        invalidHash: false,
        invalidCustomer: false,
        invalidDetails: true,
        status: "",
        networkError: ""
      };

    case RESET_VERIFY_OTP:
      return (state = initialState);

    default:
      return state;
  }
};
